import { type ThemeOptions } from '@mui/material';

export function createTableSortLabelStyles() {
  return {
    MuiTableSortLabel: {
      styleOverrides: {
        root: ({ theme }) => ({
          '&.Mui-focusVisible': {
            borderRadius: `${theme.ui.focus.borderRadius}`,
            outline: `${theme.ui.focus.outlineWidth} solid ${theme.palette.action.focusOutline}`,
            outlineOffset: `${theme.ui.focus.outlineOffset}`,
            zIndex: 1, // Ensure the outline is above the shadow
          },
        }),
      },
    },
  } as ThemeOptions['components'];
}
